import { render, staticRenderFns } from "./Ddcx.vue?vue&type=template&id=25a4bcd4&scoped=true&"
import script from "./Ddcx.vue?vue&type=script&lang=js&"
export * from "./Ddcx.vue?vue&type=script&lang=js&"
import style0 from "./Ddcx.vue?vue&type=style&index=0&id=25a4bcd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a4bcd4",
  null
  
)

export default component.exports